export const SET_USER_SECURITY_STATUS = 'SET_USER_SECURITY_STATUS';
export const CLEAR_USER_SECURITY_STATUS = 'SET_USER_SECURITY_STATUS';


export const setUserSecurityStatus = (data) => ({ type: SET_USER_SECURITY_STATUS, data });
export const clearUserSecurityStatus = () => ({ type: CLEAR_USER_SECURITY_STATUS });



// WEBPACK FOOTER //
// ./src/actions/utilityActions.js